// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sessions-page .filter-bar {
  display: flex;
  justify-content: space-between;
  background-color: #002869;
  width: 100%;
  min-height: 2em;
}
.sessions-page .filter-bar .schedule-filter {
  display: flex;
  align-items: center;
  color: white;
}
.sessions-page .filter-bar .schedule-filter label {
  margin: 5px;
}
.sessions-page .filter-bar .custom-filter {
  display: flex;
  align-items: center;
  color: white;
  margin: 5px;
  cursor: pointer;
}
.sessions-page .session-link {
  width: calc(100% - 100px);
}
.sessions-page .session-link:hover {
  text-decoration: none;
}
.sessions-page .session-icons {
  margin: 0.5em;
  position: absolute;
  right: 0;
  top: 0;
  color: #606060;
}
.sessions-page .session-icons ul li {
  list-style-type: none;
}
.sessions-page .session {
  color: black;
  border: 0.5px solid #eaeaea;
  line-height: 10px;
  text-decoration: none;
  position: relative;
}
.sessions-page .session:not(.no-hover):hover {
  background: #d4e4e9;
}
.sessions-page .session-time {
  background: #909092;
  color: white;
  padding: 10px;
}
.sessions-page .session-reg {
  text-align: center;
  width: 90px;
}
.sessions-page .session-reg .fa {
  margin-top: 0.1em;
  font-size: 2.25em;
}
.sessions-page .session-reg .fa.fa-plus-circle {
  color: gray;
}
.sessions-page .session-reg .fa.fa-check-circle {
  color: #4330ff;
}
.sessions-page .session-reg .fa.fa-check-circle.yellow {
  color: #feb52b;
}
.sessions-page .session-reg .fa.fa-check-circle.grey {
  color: grey;
}
.sessions-page .p2p-reg {
  color: gray;
  border: 0px solid #eaeaea;
  text-align: center;
  width: 90px;
  line-height: 1.2;
  padding-top: 10px;
  background-color: white;
}
.sessions-page .track-color {
  display: inline;
  padding: 1px;
  float: left;
  width: 0.25em;
  min-height: 4.5em;
  margin-right: 0.35em;
}
.sessions-page .session-reg {
  border: 0.5px solid #eaeaea;
  border-right: none;
  background: #f2f2f2;
  padding-right: 0px !important;
}
.sessions-page .session-reg p {
  margin: 5px 0px 0px -3px;
  text-align: center;
}
.sessions-page .session-name {
  padding-top: 10px;
  color: black;
  line-height: 1em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* These are technically the same, but use both */
  overflow-wrap: break-word;
  word-wrap: break-word;
  -ms-word-break: break-all;
  /* This is the dangerous one in WebKit, as it breaks things wherever */
  word-break: break-all;
  /* Instead use this non-standard one: */
  word-break: break-word;
  display: block;
}
.sessions-page .session-room {
  padding-top: 0px;
  color: #909092;
  font-size: 12px;
}
.sessions-page .session.itinerary {
  padding: 20px;
}
.sessions-page .session.itinerary .session-name {
  color: #909092;
}
.sessions-page .session.itinerary:hover {
  cursor: default;
  background: none;
}
.sessions-page .blue {
  color: #4330ff;
}
.sessions-page .carousel {
  min-height: 67px;
}
.sessions-page .disabled {
  opacity: 0.3;
}
@media only screen and (min-width: 575px) {
  .sessions-page .carousel {
    min-height: 99px;
  }
}
@media only screen and (min-width: 767px) {
  .sessions-page .carousel {
    min-height: 134px;
  }
}
@media only screen and (min-width: 991px) {
  .sessions-page .carousel {
    min-height: 181px;
  }
}
@media only screen and (min-width: 1200px) {
  .sessions-page .carousel {
    min-height: 215px;
  }
}

.alt-venue {
  margin-bottom: 0;
}

.p2p-session-row {
  color: #606060 !important;
}

.session-page hr {
  margin-top: 0;
  margin-bottom: 0;
}
.session-page .session-actions {
  padding-top: 1em;
}
.session-page .session-actions button {
  width: 100%;
  border-radius: 5px;
  background-color: #f2f2f2;
  border: 1px solid #c0c0c0;
  color: #4330ff;
  margin-bottom: 0.5em;
}
.session-page .session-actions button.unregister {
  background-color: #4330ff;
  color: #fff;
}
.session-page .session-actions button.unregister-disabled {
  color: #606060;
  background-color: #f2f2f2;
}
.session-page .session-actions button.complete-p2p {
  color: #fff;
  background-color: #fa504b;
}
.session-page .session-actions .active-button {
  background-color: #4330ff;
  color: white;
}
.session-page .session-actions .reg-helper-text {
  text-align: center;
  text-transform: capitalize;
  color: #606060;
  margin-bottom: 0.5em;
}
.session-page .session-schedule {
  color: #909092;
  font-size: 12px;
}
.session-page .blue-header {
  color: #4330ff;
  width: 100%;
  margin-top: 2em;
  display: block;
}
.session-page .user-list {
  padding: 5px 0 5px 0;
  position: relative;
}
.session-page .user-list .user-icons {
  position: absolute;
  right: 0;
  top: 0;
}
.session-page .user-list .user-icons ul li {
  list-style-type: none;
}
.session-page .sponsor-row img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: auto;
  max-width: 225px;
}
.session-page .comment-form-header {
  display: block;
}
.session-page .comment-form-header h4 {
  display: inline-block;
}
.session-page .save-comment {
  float: right;
  color: #4330ff;
  background-color: #f2f2f2;
  border: 1px solid #c0c0c0;
  border-radius: 5px;
  margin: 0.5em 0;
  padding: 3px 50px 3px 50px;
  display: inline-block;
}
.session-page .save-comment:hover {
  cursor: pointer;
  color: black;
}
.session-page .user-comment {
  color: #909092;
  font-size: 12px;
  white-space: -moz-pre-wrap; /* Firefox */
  white-space: -pre-wrap; /* ancient Opera */
  white-space: -o-pre-wrap; /* newer Opera */
  white-space: pre-wrap; /* Chrome; W3C standard */
  word-wrap: break-word; /* IE */
  position: relative;
}
.session-page .user-comment hr {
  margin-top: 15px;
}
.session-page .user-comment .time-ago {
  position: absolute;
  margin: 0.5em;
  top: 0;
  right: 0;
}
.session-page {
  /*Media Section*/
}
.session-page .media-section a {
  color: #000;
  display: block;
  width: 100%;
  float: left;
}
.session-page .media-section a:hover {
  text-decoration: none;
}
.session-page .media-section a ul {
  float: left;
}
.session-page .media-section a ul li {
  border-bottom: none;
  margin: -10px 15px;
  color: #c0c0c0;
}
.session-page .media-section a ul li.attachment-title {
  font-size: 1.1em;
  font-weight: bold;
  color: #000;
}
.session-page .media-section a ul li:hover {
  background: transparent;
}
.session-page .media-section .fa {
  font-size: 2.5em;
}
.session-page .media-section .chevron {
  color: #c0c0c0;
  font-size: 0.75em;
}
.session-page .media-section ul {
  padding-left: 0px;
}
.session-page .media-section ul li {
  list-style: none;
  border-bottom: 2px solid #eaeaea;
  padding: 0.5em 0;
  display: block;
  width: 100%;
  float: left;
}
.session-page .media-section ul li:hover {
  background-color: #f2f2f2;
}

.note-page .session-schedule:hover {
  cursor: pointer;
  background: #f2f2f2;
}

@media only screen and (max-width: 760px) {
  .sessions-page .session-reg {
    width: 60px;
    font-size: 12px;
  }
}
@media only screen and (max-width: 760px) {
  .sessions-page .p2p-reg {
    width: 60px;
    font-size: 12px;
  }
}
.peer-to-peer-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 5px 2px;
}
.peer-to-peer-container .taken-icon {
  font-size: 22px;
  color: #4330ff;
  margin-right: 20px;
}

.peer-to-peer-title {
  font-weight: 600;
}

.peer-to-peer-location {
  font-size: 13px;
  font-weight: 400;
  color: gray;
  margin-top: 20px;
}

.cancel-button {
  margin-top: 25px;
  border: 0px;
  background-color: #fa504b;
  color: white;
}

`, "",{"version":3,"sources":["webpack://./src/components/Sessions/sessions.scss","webpack://./src/app/variables.scss","webpack://./src/components/Sessions/sessions.css"],"names":[],"mappings":"AAGE;EACE,aAAA;EACA,8BAAA;EACA,yBCsBW;EDrBX,WAAA;EACA,eAAA;AEFJ;AFGI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AEDN;AFEM;EACE,WAAA;AEAR;AFGI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AEDN;AFIE;EACE,yBAAA;AEFJ;AFGI;EACE,qBAAA;AEDN;AFIE;EACE,aAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,cCtBe;ACoBnB;AFGI;EACE,qBAAA;AEDN;AFIE;EACE,YAAA;EACA,2BAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;AEFJ;AFIE;EACE,mBC1Cc;ACwClB;AFIE;EACE,mBCxCgB;EDyChB,YAAA;EACA,aAAA;AEFJ;AFKE;EACE,kBAAA;EACA,WAAA;AEHJ;AFII;EACE,iBAAA;EACA,iBAAA;AEFN;AFGM;EACE,WAAA;AEDR;AFGM;EACE,cCzCM;ACwCd;AFEQ;EACE,cCnEM;ACmEhB;AFEQ;EACE,WAAA;AEAV;AFKE;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AEHJ;AFKE;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;AEHJ;AFKE;EACE,2BAAA;EACA,kBAAA;EACA,mBCxFY;EDyFZ,6BAAA;AEHJ;AFII;EACE,wBAAA;EACA,kBAAA;AEFN;AFKE;EACE,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iDAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,sEAAA;EACA,qBAAA;EACA,uCAAA;EACA,sBAAA;EACA,cAAA;AEHJ;AFKE;EACE,gBAAA;EACA,cC/GgB;EDgHhB,eClFM;AC+EV;AFKE;EACE,aAAA;AEHJ;AFII;EACE,cCrHc;ACmHpB;AFII;EACE,eAAA;EACA,gBAAA;AEFN;AFKE;EACE,cC/GU;AC4Gd;AFKE;EACE,gBAAA;AEHJ;AFKE;EACE,YAAA;AEHJ;AFKE;EACE;IACE,gBAAA;EEHJ;AACF;AFKE;EACE;IACE,iBAAA;EEHJ;AACF;AFKE;EACE;IACE,iBAAA;EEHJ;AACF;AFKE;EACE;IACE,iBAAA;EEHJ;AACF;;AFOA;EACE,gBAAA;AEJF;;AFMA;EACE,yBAAA;AEHF;;AFME;EACE,aAAA;EACA,gBAAA;AEHJ;AFKE;EACE,gBAAA;AEHJ;AFII;EACE,WAAA;EACA,kBAAA;EACA,yBC9KU;ED+KV,yBAAA;EACA,cC/JQ;EDgKR,oBAAA;AEFN;AFGM;EACE,yBClKM;EDmKN,WAAA;AEDR;AFGM;EACE,cAAA;EACA,yBCxLQ;ACuLhB;AFGM;EACE,WAAA;EACA,yBCvKA;ACsKR;AFII;EACE,yBC/KQ;EDgLR,YAAA;AEFN;AFII;EACE,kBAAA;EACA,0BAAA;EACA,cCjMa;EDkMb,oBAAA;AEFN;AFKE;EACE,cCxMgB;EDyMhB,eC3KM;ACwKV;AFKE;EACE,cC9LU;ED+LV,WAAA;EACA,eAAA;EACA,cAAA;AEHJ;AFKE;EACE,oBAAA;EACA,kBAAA;AEHJ;AFII;EACE,kBAAA;EACA,QAAA;EACA,MAAA;AEFN;AFGM;EACE,qBAAA;AEDR;AFKE;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;AEHJ;AFKE;EACE,cAAA;AEHJ;AFII;EACE,qBAAA;AEFN;AFKE;EACE,YAAA;EACA,cC9NU;ED+NV,yBChPY;EDiPZ,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,0BAAA;EACA,qBAAA;AEHJ;AFII;EACE,eAAA;EACA,YAAA;AEFN;AFKE;EACE,cCzPgB;ED0PhB,eC5NM;ED6NN,0BAAA,EAAA,YAAA;EACA,sBAAA,EAAA,kBAAA;EACA,wBAAA,EAAA,gBAAA;EACA,qBAAA,EAAA,yBAAA;EACA,qBAAA,EAAA,OAAA;EACA,kBAAA;AEHJ;AFII;EACE,gBAAA;AEFN;AFII;EACE,kBAAA;EACA,aAAA;EACA,MAAA;EACA,QAAA;AEFN;AFrGA;EA0GE,gBAAA;AEFF;AFII;EACE,WAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;AEFN;AFGM;EACE,qBAAA;AEDR;AFGM;EACE,WAAA;AEDR;AFEQ;EACE,mBAAA;EACA,kBAAA;EACA,cCzRI;ACyRd;AFCU;EACE,gBAAA;EACA,iBAAA;EACA,WAAA;AECZ;AFCU;EACE,uBAAA;AECZ;AFII;EACE,gBAAA;AEFN;AFII;EACE,cCzSQ;ED0SR,iBAAA;AEFN;AFII;EACE,iBAAA;AEFN;AFGM;EACE,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;AEDR;AFEQ;EACE,yBC1TM;AC0ThB;;AFSI;EACE,eAAA;EACA,mBCrUU;AC+ThB;;AFWA;EACE;IACE,WAAA;IACA,eAAA;EERF;AACF;AFWA;EACE;IACE,WAAA;IACA,eAAA;EETF;AACF;AFYA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;AEVF;AFWE;EACE,eAAA;EACA,cC9UU;ED+UV,kBAAA;AETJ;;AFaA;EACE,gBAAA;AEVF;;AFaA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AEVF;;AFaA;EACE,gBAAA;EACA,WAAA;EACA,yBC7VM;ED8VP,YAAA;AEVD","sourcesContent":["@import '../../app/variables.scss';\n\n.sessions-page {\n  .filter-bar {\n    display: flex;\n    justify-content: space-between;\n    background-color: $gartner-blue;\n    width: 100%;\n    min-height: 2em;\n    .schedule-filter {\n      display: flex;\n      align-items: center;\n      color: white;\n      label {\n        margin: 5px;\n      }\n    }\n    .custom-filter {\n      display: flex;\n      align-items: center;\n      color: white;\n      margin: 5px;\n      cursor: pointer;\n    }\n  }\n  .session-link {\n    width: calc(100% - 100px);\n    &:hover{\n      text-decoration: none;\n    }\n  }\n  .session-icons {\n    margin: .5em;\n    position: absolute;\n    right: 0;\n    top: 0;\n    color: $medium-dark-gray;\n    ul li {\n      list-style-type: none;\n    }\n  }\n  .session {\n    color: black;\n    border: 0.5px solid $light-gray;\n    line-height: 10px;\n    text-decoration: none;\n    position: relative;\n  }\n  .session:not(.no-hover):hover {\n    background: $blue-light-gray;\n  }\n  .session-time{\n    background: $medium-light-gray;\n    color: white;\n    padding: 10px;\n  }\n\n  .session-reg {\n    text-align: center;\n    width: 90px;\n    .fa {\n      margin-top: .1em;\n      font-size: 2.25em;\n      &.fa-plus-circle {\n        color: gray;\n      }\n      &.fa-check-circle {\n        color: $evanta-blue;\n        &.yellow {\n          color: $warning-color;\n        }\n        &.grey {\n          color: grey\n        }\n      }\n    }\n  }\n  .p2p-reg {\n    color: gray;\n    border: 0px solid $light-gray;\n    text-align: center;\n    width: 90px;\n    line-height: 1.2;\n    padding-top: 10px;\n    background-color: white;\n  }\n  .track-color {\n    display: inline;\n    padding: 1px;\n    float: left;\n    width: .25em;\n    min-height: 4.5em;\n    margin-right: .35em;\n  }\n  .session-reg {\n    border: 0.5px solid $light-gray;\n    border-right: none;\n    background: $lightest-gray;\n    padding-right: 0px !important;\n    p {\n      margin: 5px 0px 0px -3px;\n      text-align: center;\n    }\n  }\n  .session-name {\n    padding-top: 10px;\n    color: black;\n    line-height: 1em;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    /* These are technically the same, but use both */\n    overflow-wrap: break-word;\n    word-wrap: break-word;\n    -ms-word-break: break-all;\n    /* This is the dangerous one in WebKit, as it breaks things wherever */\n    word-break: break-all;\n    /* Instead use this non-standard one: */\n    word-break: break-word;\n    display: block;\n  }\n  .session-room {\n    padding-top: 0px;\n    color: $medium-light-gray;\n    font-size: $smaller;\n  }\n  .session.itinerary {\n    padding: 20px;\n    .session-name {\n      color: $medium-light-gray;\n    }\n    &:hover {\n      cursor: default;\n      background: none;\n    }\n  }\n  .blue {\n    color: $evanta-blue;\n  }\n  .carousel {\n    min-height: 67px;\n  }\n  .disabled {\n    opacity: 0.3;\n  }\n  @media only screen and (min-width : 575px){\n    .carousel {\n      min-height: 99px;\n    }\n  }\n  @media only screen and (min-width : 767px){\n    .carousel {\n      min-height: 134px;\n    }\n  }\n  @media only screen and (min-width : 991px){\n    .carousel {\n      min-height: 181px;\n    }\n  }\n  @media only screen and (min-width : 1200px){\n    .carousel {\n      min-height: 215px;\n    }\n  }\n}\n\n.alt-venue {\n  margin-bottom: 0;\n}\n.p2p-session-row {\n  color: #606060 !important;\n}\n.session-page {\n  hr {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n  .session-actions {\n    padding-top: 1em;\n    button {\n      width: 100%;\n      border-radius: 5px;\n      background-color: $lightest-gray;\n      border: 1px solid $medium-gray;\n      color: $evanta-blue;\n      margin-bottom: 0.5em;\n      &.unregister {\n        background-color: $evanta-blue;\n        color: #fff;\n      }\n      &.unregister-disabled{\n        color:#606060;\n        background-color: $lightest-gray;\n      }\n      &.complete-p2p{\n        color:#fff;\n        background-color: $solar;\n      }\n    }\n    .active-button {\n      background-color: $evanta-blue;\n      color: white;\n    }\n    .reg-helper-text {\n      text-align: center;\n      text-transform: capitalize;\n      color: $medium-dark-gray;\n      margin-bottom: 0.5em;\n    }\n  }\n  .session-schedule {\n    color: $medium-light-gray;\n    font-size: $smaller;\n  }\n  .blue-header {\n    color: $evanta-blue;\n    width: 100%;\n    margin-top: 2em;\n    display: block;\n  }\n  .user-list {\n    padding: 5px 0 5px 0;\n    position: relative;\n    .user-icons {\n      position: absolute;\n      right: 0;\n      top: 0;\n      ul li {\n        list-style-type: none;\n      }\n    }\n  }\n  .sponsor-row img {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    height: auto;\n    max-width: 225px;\n  }\n  .comment-form-header {\n    display: block;\n    h4 {\n      display: inline-block;\n    }\n  }\n  .save-comment {\n    float: right;\n    color: $evanta-blue;\n    background-color: $lightest-gray;\n    border: 1px solid $medium-gray;\n    border-radius: 5px;\n    margin: .5em 0;\n    padding: 3px 50px 3px 50px;\n    display: inline-block;\n    &:hover {\n      cursor: pointer;\n      color: black;\n    }\n  }\n  .user-comment {\n    color: $medium-light-gray;\n    font-size: $smaller;\n    white-space: -moz-pre-wrap; /* Firefox */\n    white-space: -pre-wrap; /* ancient Opera */\n    white-space: -o-pre-wrap; /* newer Opera */\n    white-space: pre-wrap; /* Chrome; W3C standard */\n    word-wrap: break-word; /* IE */\n    position: relative;\n    hr {\n      margin-top: 15px;\n    }\n    .time-ago {\n      position: absolute;\n      margin: .5em;\n      top: 0;\n      right: 0;\n    }\n  }\n  /*Media Section*/\n  .media-section {\n    a {\n      color: #000;\n      display: block;\n      width: 100%;\n      float: left;\n      &:hover {\n        text-decoration: none;\n      }\n      ul {\n        float: left;\n        li {\n          border-bottom: none;\n          margin: -10px 15px;\n          color: $medium-gray;\n          &.attachment-title{\n            font-size: 1.1em;\n            font-weight: bold;\n            color: #000;\n          }\n          &:hover {\n            background: transparent;\n          }\n        }\n      }\n    }\n    .fa{\n      font-size: 2.5em;\n    }\n    .chevron {\n      color: $medium-gray;\n      font-size: .75em;\n    }\n    ul {\n      padding-left: 0px;\n      li {\n        list-style: none;\n        border-bottom: 2px solid $light-gray;\n        padding: .5em 0;\n        display: block;\n        width: 100%;\n        float: left;\n        &:hover{\n          background-color: $lightest-gray;\n        }\n      }\n    }\n  }\n}\n\n.note-page {\n  .session-schedule{\n    &:hover {\n      cursor: pointer;\n      background: $lightest-gray;\n    }\n  }\n}\n\n@media only screen and (max-width : 760px){\n  .sessions-page .session-reg {\n    width: 60px;\n    font-size: 12px;\n  }\n}\n\n@media only screen and (max-width : 760px){\n  .sessions-page .p2p-reg {\n    width: 60px;\n    font-size: 12px;\n  }\n}\n\n.peer-to-peer-container {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding: 5px 2px;\n  .taken-icon {\n    font-size: 22px;\n    color: $evanta-blue;\n    margin-right: 20px;\n\t}\n}\n\n.peer-to-peer-title {\n  font-weight: 600;\n}\n\n.peer-to-peer-location {\n  font-size: 13px;\n  font-weight: 400;\n  color: gray;\n  margin-top: 20px;\n}\n\n.cancel-button {\n  margin-top: 25px;\n  border: 0px;\n  background-color: $solar;\n\tcolor: white;\n}\n","// Font colors\n$success-color: #38bb15;\n$warning-color: #feb52b;\n$error-color: #ff2e2e;\n$link-color: #428bca;\n\n$blue: #2d7cbf;\n$blue-light-gray: #d4e4e9;\n\n$lightest-gray: #f2f2f2;\n$light-gray: #eaeaea;\n$medium-lightest-gray: #dcdcdc;\n$medium-light-gray: #909092;\n$medium-gray: #c0c0c0;\n$medium-dark-gray: #606060;\n$dark-gray: #404040;\n\n$teal: #32c3b5;\n$gold: #f2b130;\n\n$light-base: #006AC7;\n$light-active: #264A82;\n$success-base: #00A76D;\n\n$eblack: #282829;\n$egrey: #dcddde;\n$evanta-blue: #4330ff;\n$evanta-blue-secondary: #5c4ee5;\n$gartner-blue: #002869;\n$active-slider: #3fe85c;\n$solar: #fa504b;\n$solar-secondary: #fb736f;\n$solar-tertiary: #DE0A01;\n\n\n// Font sizes\n$biggest-header: 36px;\n$big-header: 28px;\n$larger: 20px;\n$large: 16px;\n$medium: 14px;\n$small: 13px;\n$smaller: 12px;\n$tiny: 11px;\n\n// Homepage colors\n// $goldLight: #F9D889;\n// $goldPrimary: #F4B213;\n// $goldDark: #92451C;\n// $greenLight: #CDE3A5;\n// $greenPrimary: #9CC84B;\n// $greenDark: #416428;\n// $mintLight: #95E1DA;\n// $mintPrimary: #2BC4B6;\n// $mintDark: #00566B;\n// $purpleLight: #C6B1D4;\n// $purplePrimary: #8D64AA;\n// $purpleDark: #46295B;\n\n$goldLight: #F9D783;\n$goldPrimary: #92451C;\n$goldDark: #F5B51D;\n$greenLight: #C7E09A;\n$greenPrimary: #416428;\n$greenDark: #A0CA51;\n$mintLight: #8EDFD8;\n$mintPrimary: #02576C;\n$mintDark: #33C7B9;\n$purpleLight: #C3ADD2;\n$purplePrimary: #513465;\n$purpleDark: #9068AD;\n\n\n// virtual portal colors\n$vp-dark-gray: #6D6E71;\n$vp-black: #2C2C2C;\n$vp-bright-red: #FA504B;\n$vp-dark-gray-50op: rgba(109, 110, 113, 0.5)\n",".sessions-page .filter-bar {\n  display: flex;\n  justify-content: space-between;\n  background-color: #002869;\n  width: 100%;\n  min-height: 2em;\n}\n.sessions-page .filter-bar .schedule-filter {\n  display: flex;\n  align-items: center;\n  color: white;\n}\n.sessions-page .filter-bar .schedule-filter label {\n  margin: 5px;\n}\n.sessions-page .filter-bar .custom-filter {\n  display: flex;\n  align-items: center;\n  color: white;\n  margin: 5px;\n  cursor: pointer;\n}\n.sessions-page .session-link {\n  width: calc(100% - 100px);\n}\n.sessions-page .session-link:hover {\n  text-decoration: none;\n}\n.sessions-page .session-icons {\n  margin: 0.5em;\n  position: absolute;\n  right: 0;\n  top: 0;\n  color: #606060;\n}\n.sessions-page .session-icons ul li {\n  list-style-type: none;\n}\n.sessions-page .session {\n  color: black;\n  border: 0.5px solid #eaeaea;\n  line-height: 10px;\n  text-decoration: none;\n  position: relative;\n}\n.sessions-page .session:not(.no-hover):hover {\n  background: #d4e4e9;\n}\n.sessions-page .session-time {\n  background: #909092;\n  color: white;\n  padding: 10px;\n}\n.sessions-page .session-reg {\n  text-align: center;\n  width: 90px;\n}\n.sessions-page .session-reg .fa {\n  margin-top: 0.1em;\n  font-size: 2.25em;\n}\n.sessions-page .session-reg .fa.fa-plus-circle {\n  color: gray;\n}\n.sessions-page .session-reg .fa.fa-check-circle {\n  color: #4330ff;\n}\n.sessions-page .session-reg .fa.fa-check-circle.yellow {\n  color: #feb52b;\n}\n.sessions-page .session-reg .fa.fa-check-circle.grey {\n  color: grey;\n}\n.sessions-page .p2p-reg {\n  color: gray;\n  border: 0px solid #eaeaea;\n  text-align: center;\n  width: 90px;\n  line-height: 1.2;\n  padding-top: 10px;\n  background-color: white;\n}\n.sessions-page .track-color {\n  display: inline;\n  padding: 1px;\n  float: left;\n  width: 0.25em;\n  min-height: 4.5em;\n  margin-right: 0.35em;\n}\n.sessions-page .session-reg {\n  border: 0.5px solid #eaeaea;\n  border-right: none;\n  background: #f2f2f2;\n  padding-right: 0px !important;\n}\n.sessions-page .session-reg p {\n  margin: 5px 0px 0px -3px;\n  text-align: center;\n}\n.sessions-page .session-name {\n  padding-top: 10px;\n  color: black;\n  line-height: 1em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  /* These are technically the same, but use both */\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  -ms-word-break: break-all;\n  /* This is the dangerous one in WebKit, as it breaks things wherever */\n  word-break: break-all;\n  /* Instead use this non-standard one: */\n  word-break: break-word;\n  display: block;\n}\n.sessions-page .session-room {\n  padding-top: 0px;\n  color: #909092;\n  font-size: 12px;\n}\n.sessions-page .session.itinerary {\n  padding: 20px;\n}\n.sessions-page .session.itinerary .session-name {\n  color: #909092;\n}\n.sessions-page .session.itinerary:hover {\n  cursor: default;\n  background: none;\n}\n.sessions-page .blue {\n  color: #4330ff;\n}\n.sessions-page .carousel {\n  min-height: 67px;\n}\n.sessions-page .disabled {\n  opacity: 0.3;\n}\n@media only screen and (min-width: 575px) {\n  .sessions-page .carousel {\n    min-height: 99px;\n  }\n}\n@media only screen and (min-width: 767px) {\n  .sessions-page .carousel {\n    min-height: 134px;\n  }\n}\n@media only screen and (min-width: 991px) {\n  .sessions-page .carousel {\n    min-height: 181px;\n  }\n}\n@media only screen and (min-width: 1200px) {\n  .sessions-page .carousel {\n    min-height: 215px;\n  }\n}\n\n.alt-venue {\n  margin-bottom: 0;\n}\n\n.p2p-session-row {\n  color: #606060 !important;\n}\n\n.session-page hr {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.session-page .session-actions {\n  padding-top: 1em;\n}\n.session-page .session-actions button {\n  width: 100%;\n  border-radius: 5px;\n  background-color: #f2f2f2;\n  border: 1px solid #c0c0c0;\n  color: #4330ff;\n  margin-bottom: 0.5em;\n}\n.session-page .session-actions button.unregister {\n  background-color: #4330ff;\n  color: #fff;\n}\n.session-page .session-actions button.unregister-disabled {\n  color: #606060;\n  background-color: #f2f2f2;\n}\n.session-page .session-actions button.complete-p2p {\n  color: #fff;\n  background-color: #fa504b;\n}\n.session-page .session-actions .active-button {\n  background-color: #4330ff;\n  color: white;\n}\n.session-page .session-actions .reg-helper-text {\n  text-align: center;\n  text-transform: capitalize;\n  color: #606060;\n  margin-bottom: 0.5em;\n}\n.session-page .session-schedule {\n  color: #909092;\n  font-size: 12px;\n}\n.session-page .blue-header {\n  color: #4330ff;\n  width: 100%;\n  margin-top: 2em;\n  display: block;\n}\n.session-page .user-list {\n  padding: 5px 0 5px 0;\n  position: relative;\n}\n.session-page .user-list .user-icons {\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n.session-page .user-list .user-icons ul li {\n  list-style-type: none;\n}\n.session-page .sponsor-row img {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  height: auto;\n  max-width: 225px;\n}\n.session-page .comment-form-header {\n  display: block;\n}\n.session-page .comment-form-header h4 {\n  display: inline-block;\n}\n.session-page .save-comment {\n  float: right;\n  color: #4330ff;\n  background-color: #f2f2f2;\n  border: 1px solid #c0c0c0;\n  border-radius: 5px;\n  margin: 0.5em 0;\n  padding: 3px 50px 3px 50px;\n  display: inline-block;\n}\n.session-page .save-comment:hover {\n  cursor: pointer;\n  color: black;\n}\n.session-page .user-comment {\n  color: #909092;\n  font-size: 12px;\n  white-space: -moz-pre-wrap; /* Firefox */\n  white-space: -pre-wrap; /* ancient Opera */\n  white-space: -o-pre-wrap; /* newer Opera */\n  white-space: pre-wrap; /* Chrome; W3C standard */\n  word-wrap: break-word; /* IE */\n  position: relative;\n}\n.session-page .user-comment hr {\n  margin-top: 15px;\n}\n.session-page .user-comment .time-ago {\n  position: absolute;\n  margin: 0.5em;\n  top: 0;\n  right: 0;\n}\n.session-page {\n  /*Media Section*/\n}\n.session-page .media-section a {\n  color: #000;\n  display: block;\n  width: 100%;\n  float: left;\n}\n.session-page .media-section a:hover {\n  text-decoration: none;\n}\n.session-page .media-section a ul {\n  float: left;\n}\n.session-page .media-section a ul li {\n  border-bottom: none;\n  margin: -10px 15px;\n  color: #c0c0c0;\n}\n.session-page .media-section a ul li.attachment-title {\n  font-size: 1.1em;\n  font-weight: bold;\n  color: #000;\n}\n.session-page .media-section a ul li:hover {\n  background: transparent;\n}\n.session-page .media-section .fa {\n  font-size: 2.5em;\n}\n.session-page .media-section .chevron {\n  color: #c0c0c0;\n  font-size: 0.75em;\n}\n.session-page .media-section ul {\n  padding-left: 0px;\n}\n.session-page .media-section ul li {\n  list-style: none;\n  border-bottom: 2px solid #eaeaea;\n  padding: 0.5em 0;\n  display: block;\n  width: 100%;\n  float: left;\n}\n.session-page .media-section ul li:hover {\n  background-color: #f2f2f2;\n}\n\n.note-page .session-schedule:hover {\n  cursor: pointer;\n  background: #f2f2f2;\n}\n\n@media only screen and (max-width: 760px) {\n  .sessions-page .session-reg {\n    width: 60px;\n    font-size: 12px;\n  }\n}\n@media only screen and (max-width: 760px) {\n  .sessions-page .p2p-reg {\n    width: 60px;\n    font-size: 12px;\n  }\n}\n.peer-to-peer-container {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  padding: 5px 2px;\n}\n.peer-to-peer-container .taken-icon {\n  font-size: 22px;\n  color: #4330ff;\n  margin-right: 20px;\n}\n\n.peer-to-peer-title {\n  font-weight: 600;\n}\n\n.peer-to-peer-location {\n  font-size: 13px;\n  font-weight: 400;\n  color: gray;\n  margin-top: 20px;\n}\n\n.cancel-button {\n  margin-top: 25px;\n  border: 0px;\n  background-color: #fa504b;\n  color: white;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
